module.exports = __webpack_public_path__ + "static/img/tips.60abb5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tips.png
// module id = 9TDW
// module chunks = 51